import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

/**
 * Site logo. If the admin uploaded an image to the `site-logo` slot it
 * replaces the entire logo; otherwise we fall back to the original Hebrew
 * letter "נ" in a primary-colored circle + "כרם נבות" wordmark.
 */
export function SiteLogo({ variant }: { variant: "header" | "footer" }) {
  const { data } = useQuery({
    queryKey: ["site-content"],
    queryFn: api.getSiteContent,
    staleTime: 5_000,
  });
  const logoUrl = data?.images?.["site-logo"] ?? null;

  if (logoUrl) {
    const maxH = variant === "header" ? "max-h-16" : "max-h-14";
    return (
      <img
        src={logoUrl}
        alt="כרם נבות"
        className={`${maxH} w-auto object-contain`}
      />
    );
  }

  // Fallback — preserved exactly from the original SiteLayout hardcoded markup.
  if (variant === "header") {
    return (
      <>
        <span
          className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-primary text-primary-foreground font-serif text-xl"
          aria-hidden
        >
          נ
        </span>
        <span className="font-serif text-2xl font-bold text-primary tracking-wide">
          כרם נבות
        </span>
      </>
    );
  }
  return (
    <>
      <span
        className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-primary text-primary-foreground font-serif text-2xl"
        aria-hidden
      >
        נ
      </span>
      <span className="font-serif text-2xl font-bold tracking-wide">כרם נבות</span>
    </>
  );
}
